<h4 mat-dialog-title>{{ modalWindowTitle }}</h4>
<h2 style="text-align: center">Mean Maximum Power</h2>
<mat-dialog-content>
  <div [formGroup]="form" class="form-box">
    <ng-container *ngIf="!isPPDV3">
      <p>Effort</p>
      <mat-form-field appearance="outline" floatLabel="always" style="width: 25%">
        <mat-label>Time [sec]</mat-label>
        <input matInput min="12" max="1800" type="number" formControlName="duration_efforts" />
        <mat-error *ngIf="form.get('duration_efforts')?.errors && form.get('duration_efforts')?.touched"
          >Duration is between 12 and 1800
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="data.is_speed_sport" appearance="outline" floatLabel="always" style="width: 25%">
        <mat-label>Average Speed [m/s]</mat-label>
        <input matInput type="number" min="0.1" max="20" formControlName="average_speed" />
        <mat-error *ngIf="form.get('average_speed')?.errors && form.get('average_speed')?.touched"
          >Average speed goes from 0.1 to 20
        </mat-error></mat-form-field
      >
      <mat-form-field *ngIf="!data.is_speed_sport" appearance="outline" floatLabel="always" style="width: 25%">
        <mat-label>Average Power [W]</mat-label>
        <input matInput type="number" formControlName="average_power" />
        <mat-error *ngIf="form.get('average_power')?.errors && form.get('average_power')?.touched"
          >Average power must be between 0 and 5000
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Work [Joule]</mat-label>
        <input readonly matInput type="number" formControlName="work"
      /></mat-form-field>
    </ng-container>
    <mat-radio-group *ngIf="isPPDV3" (change)="selectRadioButtonEvent($event)">
      <mat-radio-button color="primary" [value]="origValue">
        <div class="u-margin-bottom-8">Your selection - click button to stay what you have selected</div>
        <mat-form-field appearance="outline" class="u-margin-right-10" floatLabel="always" style="width: 220px">
          <mat-label>Time [sec]</mat-label>
          <input matInput min="12" max="1800" type="number" formControlName="duration_efforts" />
          <mat-error *ngIf="form.get('duration_efforts')?.errors && form.get('duration_efforts')?.touched">
            Duration is between 12 and 1800
          </mat-error>
        </mat-form-field>
        <mat-form-field
          *ngIf="data.is_speed_sport"
          appearance="outline"
          class="u-margin-right-10"
          floatLabel="always"
          style="width: 220px"
        >
          <mat-label>Average Speed [m/s]</mat-label>
          <input matInput type="number" min="0.1" max="20" formControlName="average_speed" />
          <mat-error *ngIf="form.get('average_speed')?.errors && form.get('average_speed')?.touched">
            Average speed goes from 0.1 to 20
          </mat-error></mat-form-field
        >
        <mat-form-field
          *ngIf="!data.is_speed_sport"
          appearance="outline"
          class="u-margin-right-10"
          floatLabel="always"
          style="width: 220px"
        >
          <mat-label>Average Power [W]</mat-label>
          <input matInput type="number" formControlName="average_power" style="width: 220px" />
          <mat-error *ngIf="form.get('average_power')?.errors && form.get('average_power')?.touched"
            >Average power must be between 0 and 5000
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" style="width: 220px">
          <mat-label>Work [Joule]</mat-label>
          <input readonly matInput type="number" formControlName="work" style="width: 220px"
        /></mat-form-field>
        <mat-error *ngIf="form.get('duration_efforts')?.value >= 26 && form.get('duration_efforts')?.value <= 149">
          These values cannot be used. Efforts with a duration of 26s - 149s cannot be used.
        </mat-error>
      </mat-radio-button>
      <mat-radio-button color="primary" class="u-margin-top-10" [value]="newValue">
        <div class="u-margin-bottom-8">
          We found a slightly better selection - click button to choose this improved selection
        </div>
        <mat-form-field appearance="outline" class="u-margin-right-10" floatLabel="always" style="width: 220px">
          <mat-label>Time [sec]</mat-label>
          <input matInput readonly disabled type="number" [value]="optimizedData.new_time" />
        </mat-form-field>
        <mat-form-field
          *ngIf="data.is_speed_sport"
          appearance="outline"
          class="u-margin-right-10"
          floatLabel="always"
          style="width: 220px"
        >
          <mat-label>Average Speed [m/s]</mat-label>
          <input matInput readonly disabled type="number" [value]="optimizedData.new_average_value" />
        </mat-form-field>
        <mat-form-field
          *ngIf="!data.is_speed_sport"
          appearance="outline"
          class="u-margin-right-10"
          floatLabel="always"
          style="width: 220px"
        >
          <mat-label>Average Power [W]</mat-label>
          <input matInput readonly disabled type="number" [value]="optimizedData.new_average_value" />
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" style="width: 220px">
          <mat-label>Work [Joule]</mat-label>
          <input readonly matInput disabled type="number" [value]="optimizedData.new_work" style="width: 220px" />
        </mat-form-field>
      </mat-radio-button>
    </mat-radio-group>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div>
    <button mat-raised-button (click)="closeDialog()" type="button">Cancel</button>
    <button *ngIf="!isPPDV3" mat-raised-button color="primary" (click)="save()">OK</button>
    <ng-container *ngIf="isPPDV3">
      <button
        mat-raised-button
        color="primary"
        [disabled]="
          !selectedButton ||
          (selectedButton === 'original' &&
            (form.get('duration_efforts')?.value <= 11 ||
              form.get('duration_efforts')?.value > 1800 ||
              (form.get('duration_efforts')?.value >= 26 && form.get('duration_efforts')?.value <= 149)))
        "
        (click)="save()"
      >
        OK
      </button>
    </ng-container>
  </div>
</mat-dialog-actions>
